import { DownloadPlatformOs } from 'shared/api/containerApi'

export const PLATFORM_NAMES: Record<DownloadPlatformOs, string> = {
  windows: 'Windows',
  mac: 'macOS',
  linux: 'Linux'
}
